import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { HttpHelper } from "src/app/shared/class/HttpHelper";
import { Helper } from "src/app/shared/helpers/helper";
import { BASE_BACKEND, ResponseData } from "src/app/shared/http/api";
import { UmovmeEnvironment } from "src/app/shared/models/umove-environment.model";
import { AuthService } from "src/app/shared/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class UmovmeEnvironmentService {
  httpHelper = new HttpHelper();
  constructor(private http: HttpClient, private authService: AuthService) {}

  list(filters: any): Observable<ResponseData> {
    return this.http
      .get<ResponseData>(
        `${BASE_BACKEND}umovme-environment/${this.httpHelper.getQueryParams(
          filters,
          true
        )}`
      )
      .pipe(catchError(Helper.handleError));
  }

  all(): Observable<ResponseData> {
    console.log("GET ALL");
    return this.http
      .get<ResponseData>(`${BASE_BACKEND}umovme-environment/all`)
      .pipe(catchError(Helper.handleError));
  }

  detail(id: number): Observable<ResponseData> {
    return this.http
      .get<ResponseData>(`${BASE_BACKEND}umovme-environment/details/${id}`)
      .pipe(catchError(Helper.handleError));
  }

  save(body: UmovmeEnvironment): Observable<ResponseData> {
    return this.http
      .post<ResponseData>(`${BASE_BACKEND}umovme-environment/`, body)
      .pipe(catchError(Helper.handleError));
  }

  update(body: UmovmeEnvironment): Observable<ResponseData> {
    return this.http
      .put<ResponseData>(`${BASE_BACKEND}umovme-environment/`, body)
      .pipe(catchError(Helper.handleError));
  }

  remove(id: number): Observable<ResponseData> {
    return this.http
      .delete<ResponseData>(`${BASE_BACKEND}umovme-environment/${id}`)
      .pipe(catchError(Helper.handleError));
  }
}
